import api from '../api'
export default {
	namespaced: true,
	state: {
		roleList: [],
		roleTotal: ''
	},
	mutations: {
		GET_ROLE_LIST( state, data = {} ) {
			state.roleList = data.records
			state.roleTotal = data.total
		}
	},
	actions: {
		GET_ROLE_LIST( { commit, dispatch },  config ) {
			return api.getRoleList( config ).then(( res ) => {
				commit( 'GET_ROLE_LIST', res.payload )
				return res
			}).catch(( rej ) => {
				window.myVue.$message.error( rej.message )
			})
		},
		GET_ROLE_DETAIL ({ commit, dispatch }, config) {
			return api.roleDetail(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		DELETE_ROLE ({ commit, dispatch }, params) {
			return api.deleterole({
				params: params
			}).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		ADD_ROLE ({ commit, dispatch }, config) {
			return api.addrole(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		UPDATE_ROLE ({ commit, dispatch }, config) {
			return api.updaterole(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/roleManage/store/index.js